/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type MessageListQueryVariables = {
    slug: string;
    page?: number | null;
    perPage?: number | null;
};
export type MessageListQueryResponse = {
    readonly messageList: {
        readonly messages: ReadonlyArray<{
            readonly slug: string;
            readonly subject: string | null;
            readonly body: string;
            readonly sentAt: string;
            readonly sentAtDisplay: string;
            readonly senderSlug: string | null;
            readonly recipientSlugs: ReadonlyArray<string> | null;
            readonly to: ReadonlyArray<string> | null;
            readonly from: string | null;
            readonly entitySlug: string | null;
            readonly previewStatus: string;
            readonly deliveryStatus: string;
            readonly direction: string;
            readonly attachments: ReadonlyArray<{
                readonly slug: string;
                readonly url: string;
                readonly name: string | null;
                readonly type: string | null;
                readonly contentType: string;
                readonly previewUrl: string | null;
            }>;
        }>;
        readonly shipments: ReadonlyArray<{
            readonly slug: string;
            readonly title: string | null;
            readonly vinLine: string | null;
        }>;
        readonly paginationMeta: {
            readonly hasNextPage: boolean;
            readonly hasPrevPage: boolean;
            readonly page: number;
            readonly perPage: number;
            readonly totalPages: number;
        } | null;
    };
};
export type MessageListQuery = {
    readonly response: MessageListQueryResponse;
    readonly variables: MessageListQueryVariables;
};



/*
query MessageListQuery(
  $slug: String!
  $page: Int
  $perPage: Int
) {
  messageList(slug: $slug, page: $page, perPage: $perPage) {
    messages {
      slug
      subject
      body
      sentAt
      sentAtDisplay
      senderSlug
      recipientSlugs
      to
      from
      entitySlug
      previewStatus
      deliveryStatus
      direction
      attachments {
        slug
        url
        name
        type
        contentType
        previewUrl
      }
    }
    shipments {
      slug
      title
      vinLine
    }
    paginationMeta {
      hasNextPage
      hasPrevPage
      page
      perPage
      totalPages
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "page",
        "variableName": "page"
      },
      {
        "kind": "Variable",
        "name": "perPage",
        "variableName": "perPage"
      },
      {
        "kind": "Variable",
        "name": "slug",
        "variableName": "slug"
      }
    ],
    "concreteType": "MessageGroup",
    "kind": "LinkedField",
    "name": "messageList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Message",
        "kind": "LinkedField",
        "name": "messages",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentAtDisplay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "senderSlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recipientSlugs",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "to",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "from",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "entitySlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "previewStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "deliveryStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "direction",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Attachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentType",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previewUrl",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ShipmentDetail",
        "kind": "LinkedField",
        "name": "shipments",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vinLine",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Paginate",
        "kind": "LinkedField",
        "name": "paginationMeta",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPrevPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "page",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "perPage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalPages",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "MessageListQuery",
    "selections": (v4/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "MessageListQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "4fb15c8f0e0d13bfa29fce8855ae8a49",
    "id": null,
    "metadata": {},
    "name": "MessageListQuery",
    "operationKind": "query",
    "text": "query MessageListQuery(\n  $slug: String!\n  $page: Int\n  $perPage: Int\n) {\n  messageList(slug: $slug, page: $page, perPage: $perPage) {\n    messages {\n      slug\n      subject\n      body\n      sentAt\n      sentAtDisplay\n      senderSlug\n      recipientSlugs\n      to\n      from\n      entitySlug\n      previewStatus\n      deliveryStatus\n      direction\n      attachments {\n        slug\n        url\n        name\n        type\n        contentType\n        previewUrl\n      }\n    }\n    shipments {\n      slug\n      title\n      vinLine\n    }\n    paginationMeta {\n      hasNextPage\n      hasPrevPage\n      page\n      perPage\n      totalPages\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '8855db862c210048dbea9553d66c6bc7';
export default node;
